export default __webpack_public_path__ + "static/media/other27.7a59b5e1.webp";